"use client";

import { PauseIcon, PlayIcon } from "@phosphor-icons/react";
import { Button } from "@boostdev/design-system-components/client";

export interface LiveLoopButtonProps {
  readonly isLooping: boolean;
  readonly onToggle: () => void;
  readonly labelLoop: string;
  readonly labelStopLoop: string;
  readonly className?: string;
}

/**
 * Toolbar twin of DownloadButton / ShareButton. Toggles the parent's
 * loop state for the Live Photo video. Shows a Play icon when paused
 * (click to start looping) and a Pause icon when looping (click to stop).
 */
export function LiveLoopButton({
  isLooping,
  onToggle,
  labelLoop,
  labelStopLoop,
  className,
}: LiveLoopButtonProps) {
  const Icon = isLooping ? PauseIcon : PlayIcon;
  return (
    <Button
      isIconOnly
      onClick={onToggle}
      aria-label={isLooping ? labelStopLoop : labelLoop}
      aria-pressed={isLooping}
      className={className}
    >
      <Icon size={24} weight="fill" />
    </Button>
  );
}
